// Color supported formats
const COLOR_FORMAT = ["rgb", "hex", "hsl", "hsv", "hwb"];

export default COLOR_FORMAT;
